// extracted by mini-css-extract-plugin
export default {"message":"message__PpqMh","visible":"visible__+xK9Q","footer-actions":"footer-actions__l+mzu","footerActions":"footer-actions__l+mzu"};